import React, { useMemo, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { PageInfo } from '../../components/Header/PageInfo';
import { useFetchAppCategoriesQuery, useFetchAppsInCategoryQuery, } from '../../redux/api/appMarket-api-slice';
import {
  Filters,
  getFilterSortInfoFromFilterKey,
} from '../../components/Common/FilterDropDown/filters';
import { AppCategory } from '../../models/app';
import { getListFromEntityState, removeMatchingElementFromArray } from '../../utils/helpers';
import { useTranslation } from 'react-i18next';
import { prettyCategories } from '../../utils/transformationHelper';
import { FilterDropDown } from '../../components/Common/FilterDropDown';
import { generateRoute } from '../../utils/location';
import { NoResult } from '../../components/Common/NoResult'
import { AppsInCategoryParameters } from '../../redux/api/types';
import { AppMarketPageIdentifier } from '../../AppRoutes';
import { APP_GRID_LOAD_MORE_CONFIG, AppGrid } from '../../components/AppGrid';
import { SetPageTitle } from '../../components/Common/SetPageTitle';
import { useRatingsAndReviews } from '../../contexts/providers/ratings-reviews';

let defaultFilterKey = Filters.TopRated;

const allowedFilters: Filters[] = [ Filters.TopRated, Filters.MostPopular, Filters.Newest];

export const CategoryDetailsPage = () : JSX.Element => {
  const { t } = useTranslation();
  let history = useHistory();
  const { categoryId, filterKey } = useParams<{ categoryId: Uuid, filterKey: Filters }>();
  const [limit, setLimit] = useState<number>(APP_GRID_LOAD_MORE_CONFIG.maxEntriesPerPage as number + 1);
  const ratingsAndReviewsFeatureFlag = useRatingsAndReviews();

  let sort = getFilterSortInfoFromFilterKey(filterKey || defaultFilterKey);
  const queryParams: AppsInCategoryParameters = {
    categoryId,
    limit,
  };

  if (sort) queryParams.sorts = [sort];
  const { data: appsFromCategory, isLoading: appsLoading, isFetching: appsFetching } = useFetchAppsInCategoryQuery(queryParams);
  const { data: categories } = useFetchAppCategoriesQuery('');

  const category = useMemo(() => {
    return getListFromEntityState<AppCategory>(categories)?.find(appCategory => appCategory.id === categoryId);
  }, [categoryId, categories]);

  const headerText: string = prettyCategories(category?.name as string, t);

  const filterChangeHandler = (filters: Filters) => {
    history.push(
      generateRoute(AppMarketPageIdentifier.Categories, [
        categoryId,
        filters
      ]),
    );
  };

  const changeLimit = (apiLimit: number) => {
    if (apiLimit !== limit) setLimit(apiLimit);
  }

  const noAppsInCategory = appsFromCategory?.ids.length === 0;

  if (!ratingsAndReviewsFeatureFlag.enabled) {
    removeMatchingElementFromArray<Filters>(allowedFilters, Filters.TopRated);
    let topRatedFilter = Filters.TopRated;
    defaultFilterKey = Filters.MostPopular;
    if (topRatedFilter === filterKey) history.replace(generateRoute(AppMarketPageIdentifier.Categories, [
      categoryId?.toString() ?? '',
      defaultFilterKey,
    ]));
  }

  return (
    <>
      {!noAppsInCategory ?
        <>
          <SetPageTitle title={headerText}/>
          <PageInfo hideDescription={true} title={headerText} />
          <FilterDropDown
            onChangeHandlerCallback={filterChangeHandler}
            allowedFilters={allowedFilters}
            selectedFilter={(filterKey) || defaultFilterKey}
          />
          <AppGrid apps={appsFromCategory} isLoading={appsLoading} isFetching={appsFetching} setApiLimit={changeLimit}/>
        </>
        :
        <NoResult />
      }
    </>
  );
};
